import type { TDayOfWeek } from '../types';

export const daysOrder: { [key in TDayOfWeek]: number } = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6,
};
export const availableDayArray = [0, 1, 2, 3, 4, 5, 6];

export const allowedCountriesList = ['us', 'ua', 'sk', 'es', 'pl', 'fa'];

export const API_TIMEOUT = 10000;
